<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import australianStateEnum from '../enums/australianState'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                fields: [
                    { type: 'text', text: 'Email Address', value: 'emailAddress', rules: [v => !!v || 'Email Address is required', v => !(v && v.length > 320) || 'Email Address must be less than 320 characters'], isRequired: true, maxLength: 320 },
                    { type: 'enum', text: 'State', value: 'australianState', rules: [v => (v !== null && v !== '') || 'State is required'], isRequired: true, items: enumService.enumAsSelectList(australianStateEnum) },
                ],
                apiMethod: 'StateBiosecurityEmails',
                formTitle: 'State Biosecurity Email',
            }
        },
    };
</script>
